<template>
	<div class="imgText">
		<div class="warp">
			<div class="banner">
				<img src="../static/8_1.png" alt="">
			</div>
			<!-- <p class="title">
				<span>传奇刘贺</span>
				<em></em>
			</p>
			<div class="line"></div>
			<div style="overflow: scroll;padding-left:20px;">
				<ul class="tab-tilte">
			    	<li v-for="(title,index) in tabTitle" @click="tabdata(index)" :class="{active:cur==index}">{{title}}</li>
				</ul>
			</div> -->
			<div class="tab-content">
			  <div v-for="(m,index) in curdata">
			  		<dl v-for="item in m">
			  			<router-link tag="a" :to="{path:'detai',query:{id:item.id}}">
			  				<dt>
			  					<img :src="item.img" alt="">
			  				</dt>
			  			</router-link>
			  			<dd>{{item.title}}</dd>
			  		</dl>
			  </div>
			</div>
		</div>
		<div class="goback" @click="goback"></div>
	</div>
</template>
<script type="text/javascript">
	export default {
		data(){
			return{
				isActive:false,
				msg:'展开',
				tabTitle: ['身份揭秘', '其人其事'],
				curdata:'',
				allData:{
				"data0":{
						data:[{
							id:8,
							img:require('../static/2_1.png'),
							title:'红绘风格基利克斯双耳陶杯',
							etitle:'Red-figure Kylix (drinking cup)',
							time:'公元前340-公元前330年',
							etime:'340/330 BC.',
							dimensional:'高6厘米；直径26.5厘米重300克',
							edimensional:'Height 6cm ; Diameter 26.5cm',
							fromN:'安德廖洛8A号墓',
							efromN:'Weight 300g ANDRIUOLO T. 8A',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>意大利南部红绘风格基利克斯双耳陶杯，出土于安德廖洛8A号墓。杯身中央绘有一个面朝左侧的酒神的女祭司，她裸身于两棵月桂树之间，手中托着物品。</p>'
						},{
							id:9,
							img:require('../static/2_2.png'),
							title:'红绘风格双耳旋钮盖豆',
							etitle:'Red-figure Lekane (covered bowl)',
							time:'公元前4世纪末期',
							etime:'Last decades of the IV century BC.',
							material:'陶',
							ematerial:'Ceramic',
							dimensional:'高17厘米；直径24厘米重975克',
							edimensional:'Height 17cm; Diameter 24cm Weight 975g',
							fromN:'安德廖洛57A号墓',
							efromN:'57AArchaeological Park of Paestum',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>意大利南部红绘风格双耳旋钮盖豆。盖豆的边缘有黑漆描绘的竖线图案，带有旋钮的盖子上装饰有两片棕叶和两朵玫瑰花。盖豆肩部描绘了一个赤裸的男性形象，他右手托一个圆盘，左手持酒神杖。另一面绘有一只天鹅。</p>'
						},{
							id:10,
							img:require('../static/2_3.png'),
							title:'红绘风格细颈圆腹油瓶',
							etitle:'Red-figure Lekythes (oil flask)',
							time:'公元前340-公元前330年',
							etime:'340/330 BC.',
							material:'陶',
							ematerial:'Ceramic',
							dimensional:'高16.5厘米；直径9厘米重235克',
							edimensional:'Height 16.5cm ; Diameter 9cm Weight 235g',
							fromN:'安德廖洛8A号墓',
							efromN:'ANDRIUOLO T. 8A',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>红绘风格意大利细颈圆腹油瓶， 主要绘有一个面朝左侧的女性头像。</p>'
						},{
							id:11,
							img:require('../static/2_4.png'),
							title:'婚礼花瓶',
							etitle:'Lebes Gamikòs (jar associated with weddings)',
							time:'公元前4世纪末期',
							etime:'Last decades of the IV century BC.',
							material:'陶',
							ematerial:'Ceramic',
							dimensional:'高45.5厘米；直径13.5厘米重1170克',
							edimensional:'Height 45.5cm; Diameter 13.5cm Weight 1170g',
							fromN:'安德廖洛57A号墓',
							efromN:'CORREDO ANDRIUOLO T. 57A',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>意大利南部红绘风格婚礼花瓶，瓶身彩绘自下而上依次为：装饰元素。瓶腹的彩绘一面为一个身穿长袍侧立的女性形象，她右手握着一面镜子，左手托着几枚圆球，一名手握着王冠的裸体男性站在她的面前；另一面为一个持一篮鸡蛋的半裸女子坐像。人物上方带有一条蛋形图案排列的装饰，下方是海浪纹饰。花瓶肩部是翻转的棕榈叶饰和黑绘纹饰。两侧的环状手柄带有松果装饰。</p><p>婚礼花瓶的盖子和盖豆的形制相似：两面分别有一个面朝左侧的女性头像；边缘带有波浪纹饰。环状手柄上方有一个类似盖豆的结构，盖子绘有辐射状的棕榈叶纹饰，边缘也绘有相同的纹饰。花瓶的最上方连接着一个小花瓶，两侧都有女性头部侧像。</p>'
						},{
							id:12,
							img:require('../static/2_5.png'),
							title:'北壁 - 决斗和哭泣者',
							etitle:'North Slab - Duel and Crying People',
							time:'约公元前340年',
							etime:'340 BC.',
							material:'石灰岩',
							ematerial:'Travertin/Fresco',
							dimensional:'高95厘米；长227厘米；厚13厘米重617000克',
							edimensional:'Height 95cm ; Length 227cm; Thickness 13cm',
							fromN:'安德廖洛58号墓',
							efromN:'Weight 617000g ANDRIUOLO T. 58',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>这个决斗和哭泣的场景，被绘于一个双坡顶墓室的北墙上。墓墙为石灰岩，其上覆盖了灰泥壁和彩绘层。墙壁上的斯芬克斯面朝右侧，利爪几乎要抓住它前方的战士。战士身着白色衣服，衣服边缘的装饰为红色；他左手抓着两杆矛，右手握着一根头朝下的矛。战士黑髯黑发，头戴红羽黄盔，右腿后蹬，左腿前弯。他的身体被一根长矛刺穿，膝盖也险些为矛所伤。他的对手穿着白色衣服，系同色腰带，衣服两侧带有红色装饰，底襟有黑色波浪纹饰。他的头盔的样式和对手的相似。他的左臂向前伸，举着一个圆形盾牌，盾牌中心为红色，中心周围为白色，最外圈为带黑点的黄色边缘。他的右侧为一个黑髯黑发持黑笛的吹奏者。吹笛人身穿红色长袍，斜披白色披风，露出右肩，脚穿黄色鞋子。吹笛人的对面站着一个双手交叉在胸前的女人。女子深色长发披肩，戴红色项链，身着白色长裙和红色罩袍。画面右侧边缘侧身站立的女子，左手扶额，右手置于胸前，穿着和女伴相似的黄色长袍。 </p>'
						},{
							id:13,
							img:require('../static/2_6.png'),
							title:'青铜头盔',
							etitle:'Bronze Helmet',
							time:'公元前4世纪末期',
							etime:'Last decades of the IV century BC.',
							material:'青铜',
							ematerial:'Bronze',
							dimensional:'高35厘米；长29.5厘米；宽26.5厘米;重750克',
							edimensional:'Height 35cm ; Length 29.5cm; Thickness 26.5cm;Weight 750g',
							fromN:'富谢洛2号墓',
							efromN:'FUSCILLO T. 2',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>锻造而成的青铜头盔，由具有延展性的青铜带组成。头盔正面饰有压花纹，背面为波浪纹，顶部有翅形装饰。</p>'
						},{
							id:14,
							img:require('../static/2_7.png'),
							title:'红绘风格双耳旋钮盖豆',
							etitle:'Red-figure Lekane (covered bowl)',
							time:'公元前4世纪末期',
							etime:'Last decades of the IV century BC.',
							material:'陶',
							ematerial:'Ceramic',
							dimensional:'高17厘米；直径24厘米重975克',
							edimensional:'Height 17cm; Diameter 24cm Weight 975g',
							fromN:'安德廖洛57A号墓',
							efromN:'CORREDO ANDRIUOLO T.57AArchaeological Park of Paestum',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>意大利南部红绘风格双耳旋钮盖豆。盖豆的边缘有黑漆描绘的竖线图案，带有旋钮的盖子上装饰有两片棕叶和两朵玫瑰花。盖豆肩部描绘了一个赤裸的男性形象，他右手托一个圆盘，左手持酒神杖。另一面绘有一只天鹅。</p>'
						},{
							id:15,
							img:require('../static/2_10.png'),
							title:'战士',
							etitle:'Warrior',
							time:'公元前330年',
							etime:'330 BC.',
							material:'石灰岩',
							ematerial:'Travertin/Fresco',
							dimensional:'高148厘米；长90厘米；厚12厘米重300000克',
							edimensional:'H 148 cm，L 90 cm，T 12 cm Weight 300000 g',
							fromN:'安德廖洛114号，西壁',
							efromN:'West Slab,Andriuolo',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>安德廖洛墓114号墓的西墙：战士场景。</p><p>墓墙上描绘了一名手持马缰，面朝左侧的战士形象。战马通体为黄色，装备着黑的马具。战士头戴饰有红羽黑翎的头盔，身着白色短袍，腰间系黄色腰带，外披披风；足蹬黑的鞋子，着黄色护胫甲。他手中握着扛在肩上的长矛。画面两侧各有一根爱奥尼亚柱，将人物框于其中。</p>'
						},{
							id:16,
							img:require('../static/2_9.png'),
							title:'南壁 - 葬礼队伍',
							etitle:'South slab - Funeral Procession',
							time:'公元前340-公元前330年',
							etime:'340/330 BC.',
							material:'石灰岩',
							ematerial:'Travertin/Fresco',
							dimensional:'高90厘米；长150厘米；厚13厘米重386000克',
							edimensional:'Height 90cm ; Length 150cm; Thickness 13cm Weight 386000g',
							fromN:'安德廖洛8A号墓',
							efromN:'ANDRIUOLO T. 8A',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>这是一个双坡顶墓室的南墙（墓室较长的一边），墓墙为石灰岩，其上覆盖了灰泥壁和彩绘层。画面主体为三个面朝左侧的女性形象：左起第一个 女子黑色短发，赤足，穿着白色无袖长裙，手扶着顶在头上的红黄相间的桌子。桌上面摆着祭品，祭品中央是一个黑色细颈双耳瓶，双耳上缠绕着红色丝带，瓶子两旁摆放着鸡蛋和石榴。她身后跟随的两个女子都穿着黑色鞋子，其中一个黑色长发，身着黄色无袖长裙；另一个黑发女子披着红色头巾，也身着黄裙。墓墙主体画面的两侧有红色彩绘，右侧为涡形纹饰、棕榈叶饰和一颗石榴，左侧也有一颗石榴。上方有一条红色饰带和垂花饰。</p>'
						},{
							id:17,
							img:require('../static/2_8.png'),
							title:'东壁 - 通往阴间之旅',
							etitle:'East Slab - Journey to the Underworld',
							time:'公元前340-公元前330年',
							etime:'340/330 BC.',
							material:'石灰岩',
							ematerial:'Travertin/Fresco',
							dimensional:'高134厘米；长91厘米；厚10厘米 重225000克',
							edimensional:'Height 134cm ; Length 91cm; Thickness 10cm Weight 225000g',
							fromN:'安德廖洛8A号墓',
							efromN:'ANDRIUOLO T. 8A',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>通往阴间之旅的场景被绘于一个双坡顶墓室的东墙上，墓墙为石灰岩。画面中，身穿白色短衣、足蹬黑靴的长发 年轻男子，拉着由黄色皮带牵引的小车，小车上坐着的孩子也穿着类似的衣服。人物周围有花饰和下垂的丝带。墓墙尖顶的中央有一个由十一片红黑交替 的叶片组成的棕榈叶饰，棕榈叶片延伸出两条水平的枝杈，并结出两颗石榴。棕榈叶饰下方的白色饰带上有一根朝向左侧的树枝。</p>'
						}]
					}		
				},
				cur: 0 //默认选中第一个tab
			}
		},
		mounted(){
			this.curdata=this.allData['data0'];
			//console.log(this.curdata,589)
		},
		methods:{
			slidUp(){
				this.isActive=!this.isActive;
				if (this.isActive) {
					this.msg='收起'
				}else{
					this.msg='展开'
				}
			},
			tabdata(index){
				this.cur=index;
				var code='data'+index;
				this.curdata=this.allData[code];
				//console.log(this.curdata,456)
			},
			goback(){
				this.$router.go(-1)
			}
		}
	}
</script>
<style scoped>
	.goback{
		width: 0.62rem;
		height: 0.62rem;
		background:url(../static/g.png);
		background-size: 100% 100%;
		border-radius:100%;
		position: fixed;
		right: 20px;
		top: 60%;
	}
	.line{
		width:1rem;
		height: 1px;
		background:#ececec;
		margin: 0 auto;
		margin-bottom: .3rem;
	}
	.warp{
		width: 90%;
		margin: 0 auto;
		background:#fff;
		box-shadow: 0px 1px 15px #ededed;
		margin-top: 20px;
		border-radius:20px;
		padding-bottom:1rem;
		margin-bottom: 1rem;
	}
	.banner{
		width: 100%;
		border-top-left-radius:20px;
		border-top-right-radius:20px;
		margin-bottom: 0.4rem;
	}
	.banner img{
		width: 100%;
		border-top-left-radius:20px;
		border-top-right-radius:20px;
	}
	.title{
		width: 100%;
		text-align: left;
		font-size:20px;
		position: relative;
		margin-bottom: .8rem;
	}
	.title span{
		text-indent:0.14rem;
		letter-spacing: 3px;
		display: inline-block;
		z-index: 3;
		position: absolute;
	}
	.title em{
		display: inline-block;
		width: 0.85rem;
		height:9px;
		background: #e6bb70;
		left: 0.20rem;
		position: absolute;
		z-index: 1;
		top:10px;
	}
	.cont{
		width: 90%;
		margin: 0 auto;
	}
	.cont p{
		font-size: 16px;
		color:#666666;
		line-height: 30px;
		text-align: justify;
		margin-bottom: .10rem;
	}
	.cont dl{
		width: 100%;
		margin-bottom:.10rem;
	}
	.cont dl dt img{
		width: 100%;
	}
	.cont dl dd{
		font-size:14px;
		color:#adadad;
		margin-top: 0.15rem;
		line-height: 20px;
	}
	.butn{
		background:url(../static/bj1.png);
		height:.4rem;
		background-size: 100%;
		margin-top:.25rem;
		position: relative;
	}
	.btnC{
		width: 0.45rem;
		height: 0.23rem;
		border-radius: 50px;
		background:#fff;
		box-shadow: 0px 1px 15px #ededed;
		text-align: center;
		line-height: 0.23rem;
		margin: 0 auto;
		margin-top: -0.11rem;
		position: absolute;
		left: 50%;
		margin-left: -0.25rem;
		color:#e6bb70;
	}
	.activeClass{
		height: 2rem;
		overflow:hidden;
	}
	.hideClass{
		height: auto;
	}
	.tab-tilte{
	    width:1500px;
	}
	.tab-tilte li{
	    float: left;
	    width:1rem;
	    padding: 10px 0;
	    text-align: center;
	    cursor: pointer;
	    color:#cdcdcd;
	    font-size: 18px;
	    font-weight: bolder;
	}
	/* 点击对应的标题添加对应的背景颜色 */
	.tab-tilte .active{
	    color: #e6bb70;
	}
	.tab-content div{
	    width:95%;
	  	margin-top:.2rem;
	  	column-count:2;
	}		
	.tab-content div dl{
		background:#f5f5f5;
		border-radius: 4px;
		margin-left: 22px;
		padding-bottom: 30px;
		background: #fff;
	}
	.tab-content div dl dt{
		justify-content: center;
		align-items: center;
	}
	.tab-content div dl dt img{
		max-width:100%;
		max-height: 100%;
		border-radius: 4px 4px 0 0;
	}
	.tab-content div dl dd{
		height: .3rem;
		background:#fff;
		line-height: .3rem;
		text-align: center;
		border-bottom-right-radius:4px;
		border-bottom-left-radius:4px;
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
		padding:0 5px; 
		box-shadow: 0px 1px 15px #d7d7d7;
	}
</style>